import { CoreButtonView, type TCoreButtonStyleProps, type TCoreButtonViewProps } from '@core/widgets';
import { useApp } from '@libs/core';
import React from 'react';
import { getSemanticColors, memoByPalette, SemanticColor, TSemanticColors } from '../../../theme/colors';

type TCalculatorFeeButtonProps = {
    enterCodePopup: React.ReactNode;
    appliedCodePopup: React.ReactNode;
    handlingAutoApplied?: boolean;
    label: string;
    value?: string;
    parentStyleNames?: string[];
    /** Design version of the owning widget. */
    version: number | undefined;
};

const buildCodeButtonStyleProps = (colors: TSemanticColors): TCoreButtonStyleProps => ({
    variant: 'outlined',
    surface: colors[SemanticColor.FillSecondary],
    main: colors[SemanticColor.TextEmphasised],
    borderRadius: 16,
    borderStroke: 1,
    outline: colors[SemanticColor.BorderPrimary],
    fontStyle: { fontWeight: 500, fontSize: 14, lineHeight: 20 },
    padding: { top: 4, right: 16, bottom: 4, left: 16 },
    hovered: { surface: colors[SemanticColor.FillSecondaryHovered] },
    pressed: { surface: colors[SemanticColor.FillSecondaryPressed] },
});
const getCodeButtonStyleProps = memoByPalette(buildCodeButtonStyleProps);

const CodeButton = React.memo(
    ({ enterCodePopup, appliedCodePopup, label, value, handlingAutoApplied, parentStyleNames, version }: TCalculatorFeeButtonProps) => {
        const { setPopup } = useApp();
        const handleClick = () => {
            setPopup(value || handlingAutoApplied ? appliedCodePopup : enterCodePopup);
        };
        const widget = { uid: '', data: { text: label }, options: {} } as TCoreButtonViewProps['widget'];
        return (
            <CoreButtonView
                widget={widget}
                text={label}
                styleName="calculatorCodeButton"
                parentStyleNames={parentStyleNames}
                styleProps={getCodeButtonStyleProps(getSemanticColors(version))}
                onClick={handleClick}
            />
        );
    },
);
export { CodeButton };
